import { appConfig } from '../config';

export const useDocumentTitle = (title?: string) => {
  const bet = appConfig.companyName;

  return {
    title: title ? `${bet} - ${title}` : bet,
  };
};
